// Plain enum constants mirroring the Gen 2 data schema, replacing the DataStore-generated
// `../models` enums (Gen 2 drops DataStore in favour of generateClient). Values must match
// the AppSync enum members exactly.
export const CartStatus = { OPEN: 'OPEN', PAYMENT_SUCCESS: 'PAYMENT_SUCCESS', PAYMENT_FAILED: 'PAYMENT_FAILED' };
export const BreedGroup = { MIXED: 'MIXED', SMALL: 'SMALL', MEDIUM: 'MEDIUM', LARGE: 'LARGE', EXLARGE: 'EXLARGE' };
export const AgeBracket = { A: 'A', B: 'B', C: 'C', D: 'D', E: 'E', X: 'X' };
export const Plans = { RED: 'RED', YELLOW: 'YELLOW', BLUE: 'BLUE', MICROCHIP: 'MICROCHIP' };
export const AddressType = { HOME: 'HOME', WORK: 'WORK', OTHER: 'OTHER' };
export const PGOrderStatus = { Success: 'Success', Failure: 'Failure', Aborted: 'Aborted', Invalid: 'Invalid' };
